export default theme => {
  return {
    container: {
      padding: 5
    }
  }
}
